import { jsxs as t, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2447.js";
function e({ size: l = i }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: l,
      height: l,
      viewBox: "0 0 56 56",
      fill: "none",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M27.0176 22.5H17.2864C16.3718 22.5 15.9714 23.4204 15.6251 24.2164C15.5828 24.3134 15.5414 24.4086 15.5 24.5L25.5 33.6582C25.9976 34.1139 27.0024 34.1139 27.5 33.6582L31.6741 29.6043C28.9514 28.6454 27 26.0506 27 23C27 22.8319 27.0059 22.6652 27.0176 22.5Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M34 30C37.866 30 41 26.866 41 23C41 19.134 37.866 16 34 16C30.134 16 27 19.134 27 23C27 26.866 30.134 30 34 30Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M15.5243 24.4461C15.5576 24.3714 15.5911 24.2945 15.6251 24.2164C15.7562 23.915 15.8951 23.5957 16.0668 23.3153C15.7827 23.631 15.5894 24.0194 15.5243 24.4461Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M27.5 33.6583L31.6741 29.6044C32.4018 29.8606 33.1846 30 34 30C35.275 30 36.4704 29.6592 37.5 29.0636V37.2334C37.5 38.4853 36.4055 39.5001 35.0557 39.5001H17.9443C16.5945 39.5001 15.5 38.4853 15.5 37.2334V24.7667C15.5 24.6812 15.5051 24.5969 15.515 24.5138L25.5 33.6583C25.9976 34.114 27.0024 34.114 27.5 33.6583Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M37.4273 20.5789C37.6599 20.815 37.6571 21.1949 37.421 21.4274L32.94 25.8424L30.5787 23.5153C30.3427 23.2826 30.34 22.9028 30.5726 22.6667C30.8052 22.4307 31.1851 22.428 31.4211 22.6606L32.9401 24.1577L36.5788 20.5726C36.8148 20.3401 37.1947 20.3429 37.4273 20.5789Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M38 28.7453C39.8135 27.4804 41 25.3787 41 23C41 19.134 37.866 16 34 16C30.4735 16 27.5561 18.6077 27.0709 22H17.9443C16.3546 22 15 23.2038 15 24.7667V37.2333C15 38.7962 16.3546 40 17.9443 40H35.0557C36.6454 40 38 38.7962 38 37.2333V28.7453ZM34 29C37.3137 29 40 26.3137 40 23C40 19.6863 37.3137 17 34 17C30.6863 17 28 19.6863 28 23C28 26.3137 30.6863 29 34 29ZM37 29.3264V37.2333C37 38.1742 36.1656 39 35.0557 39H17.9443C16.8344 39 16 38.1742 16 37.2333V25.6394L25.2794 34.0392C25.961 34.6537 27.0463 34.6537 27.728 34.0392L32.4096 29.8186C32.03 29.7304 31.6623 29.6114 31.3092 29.4643L27.0584 33.2965C26.7572 33.568 26.2501 33.568 25.9489 33.2965L16.0574 24.3425C16.2637 23.5909 17.0054 23 17.9443 23H27C27 26.866 30.134 30 34 30C35.0736 30 36.0907 29.7583 37 29.3264Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
e.__tags = [];
export {
  e as MetricEmailSentIcon
};
//# sourceMappingURL=index.es432.js.map
